export default function Logs() {
  return (
    <div className="h-full p-6">
      <h1 className="text-2xl font-bold mb-6">日志管理</h1>
      <div className="flex items-center justify-center h-96">
        <p className="text-muted-foreground">日志管理功能开发中...</p>
      </div>
    </div>
  )
}
